import script from "./MaterialUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialUploadDialog.vue?vue&type=style&index=0&id=960dc1a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-960dc1a0"]])

export default __exports__